'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var i18nHelper = require('../../helper/i18n');

var SaveAlert = React.createClass({

    propTypes: {
        registKeyEvent: React.PropTypes.func.isRequired,
        onDismissSaveAlert: React.PropTypes.func.isRequired,
        onSave: React.PropTypes.func.isRequired,
    },

    render: function () {
        return (
            <div className='pop-alert-cover' >
                <div className='pop-alert'>
                    <img className="close" src={assetsHelper.getAsset('close2.png')} onClick={this.props.onDismissSaveAlert}/>
                    <p className="content">{i18nHelper.get('SAVE_ALERT_MSG')}</p>
                    <div className="btns">
                        <input className="save" type='button' onClick={this.sureSave} value={i18nHelper.get('BUTTON_SAVE')}/>
                        <input className="cancel" type='button' onClick={this.noSave} value={i18nHelper.get('BUTTON_CANCEL')}/>
                    </div>
                </div>
            </div>
        );
    },

    componentDidUpdate: function() {
        var context = this;
        this.props.registKeyEvent(13, function() {
            context.sureSave();
        });
    },

    componentDidMount: function() {
        var context = this;
        this.props.registKeyEvent(13, function() {
            context.sureSave();
        });
    },

    sureSave: function() {
        this.props.onSave(true);
    },

    noSave: function() {
        this.props.onSave(false);
    }

});

module.exports = SaveAlert;



// WEBPACK FOOTER //
// ./src/views/Review/SaveAlert.jsx